<template>
  <div>
    <AdminButton
      :link="reverseFull({ name: 'admin:info_legalcase_change', args: [legalCase.id] })"
      text="Править"
      class="mr-2"
    />
    <AdminButton
      :text="legalCase.get_result_display"
      class="mb-2"
    />
    <br v-if="context.request.user.is_staff && !isMobile">
    <AdminButton
      :link="`${reverseFull({ name: 'admin:info_courthearing_add' })}?legal_case=${legalCase.id}`"
      text="Добавить заседание"
      class="mb-2"
    />
    <v-card
      :href="isMobile || isLegalCaseItemPage ? undefined : reverseFull({ name: 'legal_case_page', args: [legalCase.id] })"
      class="d-flex flex-column"
      :class="isMobile && !isLegalCaseItemPage ? 'flex-column-reverse py-5 px-2' : 'pa-sm-6 pa-0 px-3'"
      data-qa="legal_case_card"
      :flat="isMobile"
    >
      <a
        v-if="isMobile && !isLegalCaseItemPage"
        :href="reverseFull({ name: 'legal_case_page', args: [legalCase.id] })"
        class="d-flex align-center text-button ml-auto text-decoration-none"
      >
        <span>
          Читать далее
        </span>
        <v-icon class="text--text">
          ui-icon-arrow-right
        </v-icon>
      </a>
      <div
        class="text--text"
        :class="isMobile && !isLegalCaseItemPage ? 'text-subtitle-1 mb-4' : 'text-h6 mb-2'"
        data-qa="legal_case_name"
      >
        {{ legalCase.name }}
      </div>
      <div
        class="mb-2"
        data-qa="legal_case_number"
        :class="isMobile ? 'text-body-1 text-secondary--text' : 'text-body-2 text-info--text'"
      >
        Дело {{ legalCaseNumber }} от {{ legalCaseDate }}
      </div>
      <div
        v-if="!isMobile || isLegalCaseItemPage"
        class="text-body-2 text--text mb-2"
        data-qa="legal_case_description"
      >
        {{ isLegalCaseItemPage ? legalCase.description : truncatedDescription }}
      </div>
      <template v-if="isLegalCaseItemPage">
        <div class="text-h6 text--text my-6">
          Судебные заседания
        </div>
        <div
          v-for="courtHearing in legalCase.courthearing_set.all"
          :key="courtHearing.id"
          class="d-flex flex-sm-row flex-column ga-sm-6 ga-2 mb-8"
        >
          <div
            class="text--text text-subtitle-2"
            data-qa="court_date"
          >
            {{ courtHearing.court_hearing_dt }}
          </div>
          <div class="d-flex flex-column ga-3">
            <AdminButton
              v-if="context.request.user.is_superuser"
              text="править"
              data-qa="admin_button"
              :link="reverseFull({ name: 'admin:info_courthearing_change', args: [courtHearing.id] })"
            />
            <div class="text--text text-subtitle-1">
              {{ courtHearing.court }}
            </div>
            <div
              v-if="courtHearing.judge"
              class="text-secondary--text text-body-2"
            >
              {{ courtHearing.judge }}
            </div>
            <div class="text-secondary--text text-body-2">
              {{ courtHearing.courts_decision }}
            </div>
            <a
              v-if="courtHearing.courts_decision_pdf.__bool__"
              :href="reverseFull({ name: 'courts_decision_pdf', args: [courtHearing.id] })"
            >
              Полное решение суда
            </a>
          </div>
        </div>
      </template>
    </v-card>
    <v-divider v-if="isMobile && !isLegalCaseItemPage" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { format, isValid } from 'date-fns'
import { useContextStore, useURLStore } from 'src/store'
import type { ContextStore } from 'src/components/pages/info/legal-case/types'
import AdminButton from 'src/components/common/AdminButton/AdminButton.vue'

const { reverseFull } = useURLStore()
const props = defineProps<{
  legalCase: ContextStore['context']['legal_cases']['__items__'][0],
  isLegalCaseItemPage?: boolean
}>()

const { context }: ContextStore = useContextStore()
const isMobile = context.flavour === 'mobile'

const legalCaseNumber = props.legalCase.number ? `№${props.legalCase.number}` : ''
const truncatedDescription = computed(() => {
  const description = props.legalCase.description?.trim() ?? ''

  return description.length > 400 ? `${description.slice(0, 400)}...` : description
})

const legalCaseDate = computed(() => {
  const date = new Date(props.legalCase.entry_dt)

  return isValid(date) ? format(date, 'dd.MM.yyyy') : ''
})
</script>

<style scoped lang="scss">
[data-qa="court_date"] {
  min-width: max-content;
}

[data-qa="admin_button"] {
  max-width: max-content;
}
</style>
